/**
 * Store 入口文件 (Pinia)
 * 统一导出所有状态管理模块
 */

import { createPinia } from 'pinia';

// 导出所有Store模块
export { useUserStore } from './user';
export { useTTSStore, INPUT_MODE } from './tts';
export { useAudioStore } from './audio';
export { useVoiceStore } from './voice';

export { useTaskStore } from './task';
export { useBatchStore } from './batch';
export { useConfigStore } from './config';
export { useLeadStrategyStore } from './leadStrategy';
export { useEntitlementStore } from './entitlement';
export { useLibraryStore } from './library';
export { useAchievementStore } from './achievement';

// 创建Pinia实例
export const pinia = createPinia();

// 默认导出
export default pinia;
